<template>
    <v-card rounded="lg">
        <v-card-title class="d-flex justify-space-between align-center">
                <div class="text-h5 font-weight-black ps-2">{{ $t('i18n.deleteDeviceModalTitle') }}</div>
                <v-btn
                  icon="mdi-close"
                  variant="text"
                  @click="closeModal"
                  size="x-large"
                ></v-btn>
        </v-card-title>
        <v-card-text class="overflow-y-auto">
          <v-row align="center">
            <v-col cols="auto">
              <v-icon icon="mdi-alert-outline" size="x-large"></v-icon>
            </v-col>
            <v-col>
              {{ $t('i18n.confirmationMessage') }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
            <v-btn class="gorate-btn-bg" rounded="xl" :text="$t('i18n.yesBtnText')" @click="deleteDevice"></v-btn>
            <v-btn class="gorate-btn-bg-outlined" variant="outlined" rounded="xl" :text="$t('i18n.noBtnText')" @click="closeModal"></v-btn>
        </v-card-actions>
    </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from '@/stores/appStore'
import { api } from '@/utils/HelperFunctions'

export default defineComponent({
  name: 'DeleteDeviceModal',
  setup () {
    const router = useRouter()
    const appStore = useAppStore()
    return {
      router,
      appStore
    }
  },
  props: {
    deviceID: {
      type: Number,
      required: true,
      default: -1
    }
  },
  methods: {
    navigate (routeName: string) {
      this.router.push({ name: routeName })
    },
    closeModal () {
      this.$emit('close-modal')
    },
    async deleteDevice () {
      try {
        const url = `/devices/${this.deviceID}`
        const deleteDeviceResponse = await api(url, 'delete')

        if (!deleteDeviceResponse) return

        if (deleteDeviceResponse.payload.statusCode === 200) this.appStore.addAlert('success', deleteDeviceResponse.payload.responseMessage)
        else this.appStore.addAlert('error', deleteDeviceResponse.payload.responseMessage)
      } catch (error) {
        this.appStore.addAlert('error', 'Error deleting device. Contact support if the error persists.')
      } finally {
        this.closeModal()
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../../styles/colors.scss";

.button-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}
</style>
